import { parseISO } from "date-fns";
import { toZonedTime } from "date-fns-tz";

export abstract class Utility<T> {
  protected get_local_time(time_string: string): Date {
    return toZonedTime(
      parseISO(time_string + "Z"),
      Intl.DateTimeFormat().resolvedOptions().timeZone,
    );
  }

  clone(): T {
    const copy: any = new (this.constructor as { new (): T })();
    return Object.assign(copy, this);
  }
}
